import Config from './config';
import Logger from '../logger';
import { device } from 'vimmi-web-utils/cjs/device';

class PlayerSrv {
  constructor() {
    this.currentPosition = 0;
    this.isChangedLang = false;
  }

  /**
   * @method getCurrentUrl
   * @description build player link
   * @return {string} current player link
   * */
  getCurrentUrl(asset = {}) {
    let opt = {
      // account: Config.get('params.account'),
      height: Config.get('params.height'),
      width: Config.get('params.width'),
      style_schema: Config.get('params.style_schema'),
      autoplay: asset.playerOptions.autoplay === true,

      showEmbedded: Config.get('params.showEmbedded') === true,
      qualityChange: Config.get('params.qualityChange') === true,
      fullScreen: Config.get('params.fullScreen') === true

      // showEmbedded: asset.playerOptions.showEmbedded === true,
      // qualityChange: asset.playerOptions.qualityChange === true,
      // fullScreen: asset.playerOptions.fullScreen === true
    };
    // if (Config.get('params.muted')) {
    //   opt.mute = true;
    // }

    if (Config.get('params.audio_tag')) {
      opt.audio_tag = true;
    }
    if (Config.get('params.font_size') && location.href.indexOf('font_size=') !== -1) {
      opt.font_size = Config.get('params.font_size');
    }

    if (Config.get('params.lang')) {
      opt.lang = Config.get('params.lang');
    }

    opt.media = asset.media_id;

    let url = new URL(location.origin + location.pathname);
    for (let name in opt) {
      if (opt[name] === false) {
        continue;
      }
      if (Array.isArray(opt[name])) {
        opt[name].map(function(_val) {
          if (_val) {
            url.searchParams.set(name + '[]', _val ? _val : '');
          }
        });
      } else {
        url.searchParams.set(name, opt[name] && opt[name] !== true ? opt[name] : '');
      }

    }

    return url.toString();
  }


  getVideoJsSrc(playbackItem, asset) {
    let opt = {
      type: playbackItem.mimeType,
      withCredentials: false
    };

    if (playbackItem.srcObject) {
      opt.srcObject = playbackItem.srcObject;
    } else {
      opt.src = playbackItem.url.toString();
    }
    /** todo: IOS PROTECTION CONTENT ISSUE */
    if ((Config.get(`params.portal.customer`) || '').toLowerCase() === 'zman' && asset.get('origin') === 'aws' && (device.isSafari() || (device.isAppleDevice() && device.isAnyMobile() && device.isChrome()))) {
      let t = new URL(playbackItem.url);
      t.host = 'zman-cf-cdn.vidnt.com';
      opt.src = t.toString();
    }

    if (playbackItem.drm) {
      let drmTypeKey = Config.get('keySystems')[playbackItem.drm.type];
      opt.keySystems = {};
      if (playbackItem.drm.type === 'HLS/FAIRPLAY') {
        delete opt.withCredentials;
        opt.keySystems[drmTypeKey] = {
          licenseUri: playbackItem.drm.license,
          certificateUri: playbackItem.drm.certificate
        };
      } else if (playbackItem.drm.type === 'DASH/PLAYREADY') {
        delete opt.keySystems;
        delete opt.withCredentials;
        opt.keySystemOptions = [ // videojs-contrib-dash
          {
            name: drmTypeKey,
            options: {
              serverURL: playbackItem.drm.license
            }
          }
        ];
      } else if (playbackItem.drm.type === 'DASH/WIDEVINE') {
        delete opt.keySystems;
        delete opt.withCredentials;
        opt.keySystemOptions = [ // videojs-contrib-dash
          {
            name: drmTypeKey,
            options: {
              serverURL: playbackItem.drm.license
            }
          }
        ];
      }
    }
    return opt;
  }

  /**
   * @method addTag
   * @return {HTMLElement}
   * @description create audio/video html tag, set required params and add it to page
   * */
  addTag(options = {}) {
    let tag;
    if (options.useTag) {
      tag = options.useTag;
    } else if (Config.get('params.audio_tag')) {
      tag = document.createElement('audio');
    } else {
      tag = document.createElement('video');
    }

    tag.id = Config.get('playerId');
    if (!options.useTag) {
      tag.setAttribute('preload', options?.tagOptions?.preload || 'auto');
      tag.setAttribute('controls', Config.get('params.controls'));
      tag.setAttribute('crossorigin', options?.tagOptions?.crossorigin || 'anonymous');
      if (options?.tagOptions?.playsinline === undefined || options?.tagOptions?.playsinline) {
        tag.setAttribute('playsinline', true);
        tag.setAttribute('webkit-playsinline', true);
      }
    }
    
    if (Config.get('params.muted')) {
      tag.setAttribute('muted', true);
    }

    tag.classList.add('video-js');
    tag.classList.add('before-init');
    tag.classList.add('custom-waiting-video');

    if (Config.get('params.font_size')) {
      tag.style.fontSize = Config.get('params.font_size');
    }
    if (!options.useTag) {
      document.body.appendChild(tag);
    }
    return tag;
  }


  transformToAsset(options) {
    let asset = {};

    asset.isLive = options.isLive;
    asset.mediaLink = options.mediaLink || null; /// for overwrite default path
    asset.amsHeaders = options.amsHeaders || null; /// to adding for default headers
    asset.origin = options.origin || null;
    // asset.cc = options.cc;
    asset.restricted = options.restricted;
    asset.media_id = options.media_id;
    if (options.metadata_url) {
      asset.playback_url = options.metadata_url;
    } else if (options.playback_url) {
      asset.playback_url = options.playback_url;
    } else if (options.mediaStream) {
      asset.mediaStream = options.mediaStream;
    }

    /** for WebRTC streaming*/


    asset.alphaId = options.alphaId;
    asset.itype = options.itype;
    asset.preview = !!options.preview;
    asset.preview_info = options.preview_info || null;
    asset.extraData = options.extraData || {};
    asset.playerOptions = options.playerOptions || {};


    if (options.autoplay) { // to tell the player what types are allowed
      asset.playerOptions.autoplay = options.autoplay;
    }
    if (options.drm_types) { // to tell the player what types are allowed
      asset.drm_types = options.drm_types;
    }
    if (options.drm) { // to tell the player do we need to use drm or no
      asset.drm = options.drm;
    }
    if (options.item) { // in case when we use the playtemplate
      asset.item = options.item;
    }
    if (options.adex) { // level conf
      asset.adex = options.adex;
    }
    if (options.adTag) { //
      asset.adTag = options.adTag;
    } else if (options.adVast) { //
      asset.adVast = options.adVast;
    }
    if (options.adVolume !== undefined) { //
      asset.adVolume = options.adVolume;
    }
    return asset;
  }
}

export default new PlayerSrv();